import { createSelector } from "reselect";
import { filter } from "@utils/fuzzySearch";

const merchants = ({ merchantArray }) => merchantArray;
const filterCards = ({ filterCards }) => filterCards;
const currentSearch = ({ currentSearch }) => currentSearch;

const currentCategory = ({ categories, categoryName }) => {
  for (const categoryType of categories) {
    for (const category of categoryType.categories) {
      if (category.url === categoryName) {
        return category;
      }
    }
  }
};

export const getMerchantArray = createSelector(
  merchants,
  filterCards,
  currentSearch,
  (merchantsParam, filterCardsParam, currentSearchParam) => {
    if (currentSearchParam) {
      return filter({
        merchants: [...merchantsParam.sort((a, b) => b.popular - a.popular)],
        pattern: currentSearchParam,
        threshold: -1500
      });
    }
    switch (filterCardsParam) {
      case "ALL":
        return [
          ...merchantsParam.sort((a, b) => {
            if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
            if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
            return 0;
          })
        ];
      case "POPULARITY":
        return [
          ...merchantsParam.sort(
            (a, b) => Number(b.popular) - Number(a.popular)
          )
        ];
      default:
        break;
    }
  }
);

export const getCategoryMerchantArray = createSelector(
  merchants,
  filterCards,
  currentCategory,
  currentSearch,
  (
    merchantsParam,
    filterCardsParam,
    currentCategoryParam,
    currentSearchParam
  ) => {
    if (currentSearchParam) {
      const filteredArray = [
        ...merchantsParam.filter(merchant => {
          let id = "" + merchant.id;
          return currentCategoryParam.merchants.indexOf(id) !== -1;
        })
      ];

      return filter({
        merchants: filteredArray.sort((a, b) => b.popular - a.popular),
        pattern: currentSearchParam,
        threshold: -1500
      });
    }
    switch (filterCardsParam) {
      case "ALL":
        return [
          ...merchantsParam
            .filter(merchant => {
              let id = "" + merchant.id;
              return currentCategoryParam.merchants.indexOf(id) !== -1;
            })
            .sort((a, b) => {
              if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
              if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
              return 0;
            })
        ];
      case "POPULARITY":
        return [
          ...merchantsParam
            .filter(merchant => {
              let id = "" + merchant.id;
              return currentCategoryParam.merchants.indexOf(id) !== -1;
            })
            .sort(
              (item, nextItem) =>
                Number(nextItem.popular) - Number(item.popular)
            )
        ];
      default:
        break;
    }
  }
);

export const getCurrentSearch = createSelector(currentSearch, item => item);
